import gql from 'graphql-tag'

export const DELETE = gql`
  mutation product_collection_delete($id: ID!) {
    productCollectionDelete(id: $id) {
      id
    }
  }
`
